import { createSelector } from 'reselect';
import { getAfyaImaraState } from './index';
import { FORM_STATUS, API_CALL_STATUS } from '../../reducers/status';

export const getQuote = createSelector(getAfyaImaraState, (state) => {
    return state && state.quote;
});

export const getQuoteForm = createSelector(getQuote, (quote) => quote && quote.form);
export const getQuoteFormValid = createSelector(getQuote, (quote) => quote && quote.formStatus === FORM_STATUS.VALID);
export const getPremiumCalculation = createSelector(getQuote, (quote) => quote && quote.premium);
export const getSelectedCoverOption = createSelector(getQuote, (quote) => quote && quote.selectedCoverOption);
export const getSelectedProductId = createSelector(getQuote, (quote) => quote && quote.productId);
export const getQuoteFormApiCallStatus = createSelector(getQuote, (quote) => quote && quote.apiCallStatus);
export const getQuotePyloadApiCallStatus = createSelector(
    getQuote,
    (quote) => quote && quote.apiPayloadCollectionStatus
);
export const getQuoteFormApiCallSuccess = createSelector(
    getQuote,
    (quote) => quote && quote.apiCallStatus === FORM_STATUS.SUCCESS
);
export const getQuoteFormApiCallFailure = createSelector(
    getQuote,
    (quote) => quote && quote.apiCallStatus === FORM_STATUS.FAILURE
);
export const getIsApiPending = createSelector(
    getQuote,
    (quote) => quote && quote.apiCallStatus === FORM_STATUS.PENDING
);
export const getAddedCover = createSelector(getQuote, (quote) => quote && quote.addedCover);
export const getPageName = createSelector(getQuote, (quote) => quote && quote.pageName);
export const getShareModalValue = createSelector(getQuote, (quote) => quote && quote.showShareModal);

export const getShowCoverOptions = createSelector(getQuote, (quote) => quote && quote.showCoverOptions);

export const getShareQuoteAPIStatus = createSelector(getQuote, (quote) => quote && quote.shareQuoteAPIStatus);
export const getShareQuoteFormStatus = createSelector(getQuote, (quote) => quote && quote.shareQuoteFormStatus);
export const getUgCmbObject = createSelector(getQuote, (quote) => quote && quote.ugCmbObject);
const makeGetFormField = (fieldId) => createSelector(getQuoteForm, (form) => form[fieldId]);
export const getIsExpiredAuth = createSelector(getQuote, (quote) => quote && quote.isTokenExpired);

export const getIsCoverOptionsApiPending = createSelector(
    getQuote,
    (quote) => quote && quote.coverOptionsApiStatus === API_CALL_STATUS.PENDING
);

export const getIsAfyaImaraProductsPending = createSelector(
    getQuote,
    (quote) => quote && quote.apiPendingProducts === API_CALL_STATUS.PENDING
);

export const getAllProducts = createSelector(getQuote, (quote) => (quote && quote.products?.products) || null);

//get is comaparisonApiCallStatus pending
export const getIsComparisonApiPending = createSelector(
    getQuote,
    (quote) => quote && quote.comparisonApiCallStatus === API_CALL_STATUS.PENDING
);

// get comparisonData
export const getComparisonData = createSelector(getQuote, (quote) => quote && quote.comparisonData);
export const getSelectedProductIndex = createSelector(getQuote, (quote) => quote && quote.selectedPlanIndex);
export const getSelectedPlanIndexComparison = createSelector(
    getQuote,
    (quote) => quote && quote.selectedPlanIndexComparison
);
//new values
export const getDOBValue = makeGetFormField('dob');
export const getCoverLimitValue = makeGetFormField('coverLimit');
export const getProfessionValue = makeGetFormField('profession');
export const getSpouseIncludedValue = makeGetFormField('spouseIncluded');
export const getSpouseDobValue = makeGetFormField('spouseDob');
export const getChildrenIncludedValue = makeGetFormField('childrenIncluded');
export const getChildrenDobsValue = makeGetFormField('childrenDobs');
export const getExcessProtectorValue = makeGetFormField('excessProtector');
export const getUncommonRiskValue = makeGetFormField('uncommonRisk');
export const getViolenceAndTerrorismValue = makeGetFormField('violenceAndTerrorism');
export const getShareEmailValue = makeGetFormField('shareEmail');
export const getCoverOptions = makeGetFormField('coverOptions');
export const getInpatientCoverValue = makeGetFormField('inpatientCover');
export const getOutpatientCoverValue = makeGetFormField('outpatientCover');
export const getOutpatientCoverOption = makeGetFormField('outpatientCoverOption');
export const getFullName = makeGetFormField('fullName');
export const getEmail = makeGetFormField('email');
export const getPhoneNumber = makeGetFormField('phoneNumber');

export const getOmRescuePlusValue = makeGetFormField('omRescuePlus');
